import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SharedBasketModal from "./SharedBasketModal";

export default function SharedBasketButton(): React.JSX.Element {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation("basket");

    const handleOpenModal = (): void => {
        setIsModalOpen(true);
    };

    const handleCloseModal = (): void => {
        setIsModalOpen(false);
    };

    return (
        <>
            <button
                id="shared-basket"
                style={{ backgroundColor: "#888" }}
                className="btn btn-primary pull-right"
                onClick={handleOpenModal}>
                <i className="fa-solid fa-share-alt"></i> {t("sharedBasketButton")}
            </button>

            <SharedBasketModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
            />
        </>
    );
}
